import _ from 'lodash';
import Debug from '@/util/debug';
import { GOAL_REACH_AND_CLICK, GOAL_LEAD_GENERATION, GOAL_LOCAL_OFFERS, GOAL_REACH_FREQUENCY, GOAL_POST_ENGAGEMENT } from '@/services/GoalTypeService';
import PackageSlider from '@/components/package-slider/PackageSlider.vue';
import { MODE_ONEOFF } from '@/services/ModeService';

const debug = Debug('package-slider-box');

export default {
  dependencies: [
    'clusterService',
  ],
  components: {
    PackageSlider,
  },
  props: {
    campaign: Object,
    availablePackages: Array,
    packagesArr: Array,
    selectedPackage: Object,
    goalTypes: Object,
    businessCategory: Object,
  },
  data() {
    return {
      loaded: false,
      clusters: [],
    };
  },
  methods: {
    offerByBudget(goalType) {
      return _.get(this.goalTypes, `${goalType}.offer_by`, 'REACH') === 'BUDGET';
    },
  },
  computed: {
    maxReach: function computedMaxReach() {
      return _.get(this.availablePackages, '[0].reach.min', 0);
    },
    isReachCampaign() {
      const goal = _.get(this.campaign, 'goal_type');
      return goal === GOAL_REACH_FREQUENCY || goal === GOAL_POST_ENGAGEMENT;
    },
    isLeadCampaign() {
      return _.get(this.campaign, 'goal_type') === GOAL_LEAD_GENERATION;
    },
    isOfferCampaign() {
      return _.get(this.campaign, 'goal_type') === GOAL_LOCAL_OFFERS;
    },
    isClicksCampaign() {
      return _.get(this.campaign, 'goal_type') === GOAL_REACH_AND_CLICK;
    },
    isOneoffCampaign() {
      return _.get(this.campaign, 'mode') === MODE_ONEOFF;
    },
    currentCluster() {
      return this.clusters.find(c => c.name === this.selectedPackage.cluster);
    },
    audienceTitle() {
      let key = 'pos.offer.audience-guaranteed';

      if (this.offerByBudget(this.campaign.goal_type)) {
        key = 'pos.offer.campaign-budget';
      }

      return this.$t(key);
    },
    estimatedClicks() {
      const clickRes = {
        min: _.get(this.selectedPackage, 'clicks.min', 0),
        max: _.get(this.selectedPackage, 'clicks.max', 0),
      };
      const multi = parseFloat(_.get(this.businessCategory, 'clicks_multiplier', 0));
      if (!isNaN(multi) && multi > 0) {
        clickRes.min *= multi;
        clickRes.max *= multi;
      }
      return clickRes;
    },
    estimatedLeads() {
      return {
        min: _.get(this.selectedPackage, 'leads.min', 0),
        max: _.get(this.selectedPackage, 'leads.max', 0),
      };
    },
    estimatedOffers() {
      return {
        min: _.get(this.selectedPackage, 'offers.min', 0),
        max: _.get(this.selectedPackage, 'offers.max', 0),
      };
    },
  },
  mounted() {
    debug('mounted');
    this.clusterService.getClusters()
      .then(clusters => {
        this.loaded = true;
        this.clusters = clusters;
      })
      .catch(err => {
        debug.error(err);
        this.loaded = true;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/package-slider-box/PackageSliderBox.js